export default {
  methods: {
    /** Get email address based on region */
    getEmailByRegion(region) {
      const regionEmailMap = {
        "Banff_Canmore": "banfforders@calliaflowers.com",
        "Barrie": "torontoorders@calliaflowers.com",
        "Barrie_Proper": "torontoorders@calliaflowers.com",
        "Calgary": "calgaryorders@calliaflowers.com",
        "Calgary_Outskirts": "calgaryorders@calliaflowers.com",
        "Edmonton": "edmontonorders@calliaflowers.com",
        "Edmonton_Outskirts": "edmontonorders@calliaflowers.com",
        "Gatineau": "ottawaorders@calliaflowers.com",
        "Halifax": "halifaxorders@calliaflowers.com",
        "Hamilton": "torontoorders@calliaflowers.com",
        "Hamilton_Outskirts": "torontoorders@calliaflowers.com",
        "Kelowna": "kelownaorders@calliaflowers.com",
        "Kelowna_Surrounding": "kelownaorders@calliaflowers.com",
        "Kingston": "ottawaorders@calliaflowers.com",
        "Kitchener_Waterloo": "torontoorders@calliaflowers.com",
        "Langley": "vancouverorders@calliaflowers.com",
        "Lethbridge": "lethbridgeorders@calliaflowers.com",
        "London": "torontoorders@calliaflowers.com",
        "Maritimes": "maritimesorders@calliaflowers.com",
        "Maritimes_NB": "maritimesorders@calliaflowers.com",
        "Maritimes_NS": "maritimesorders@calliaflowers.com",
        "Maritimes_PEI": "maritimesorders@calliaflowers.com",
        "Montreal": "montrealorders@calliaflowers.com",
        "Northern_AB": "northernalbertaorders@calliaflowers.com",
        "Okanagan": "okanaganorders@calliaflowers.com",
        "Ottawa": "ottawaorders@calliaflowers.com",
        "Ottawa_Restricted": "ottawaorders@calliaflowers.com",
        "Ottawa_Surrounding": "ottawaorders@calliaflowers.com",
        "Quebec_City": "montrealorders@calliaflowers.com",
        "Really_Rural_MB": "winnipegorders@calliaflowers.com",
        "Regina": "reginaorders@calliaflowers.com",
        "Rural_MB": "winnipegorders@calliaflowers.com",
        "Saskatoon": "saskatoonorders@calliaflowers.com",
        "Southern_AB": "southernalbertaorders@calliaflowers.com",
        "Southern_Ontario": "torontoorders@calliaflowers.com",
        "St_Catharine's_Area": "torontoorders@calliaflowers.com",
        "Surrounding_VAC": "victoriaorders@calliaflowers.com",
        "Toronto": "torontoorders@calliaflowers.com",
        "Toronto_Outskirts": "torontoorders@calliaflowers.com",
        "Toronto_Restricted": "torontoorders@calliaflowers.com",
        "Vancouver": "vancouverorders@calliaflowers.com",
        "Vancouver_Outskirts": "vancouverorders@calliaflowers.com",
        "Victoria": "victoriaorders@calliaflowers.com",
        "Winnipeg": "winnipegorders@calliaflowers.com",
        "Winnipeg_Outskirts": "winnipegorders@calliaflowers.com",
        "Winnipeg_Surrounding": "winnipegorders@calliaflowers.com"
      };

      // Try exact match first
      if (regionEmailMap[region]) {
        return regionEmailMap[region].trim();
      }

      // Try case-insensitive partial match
      const regionLower = region.toLowerCase();
      for (const [key, email] of Object.entries(regionEmailMap)) {
        if (
          key.toLowerCase().includes(regionLower) ||
          regionLower.includes(key.toLowerCase())
        ) {
          return email.trim();
        }
      }

      return null; // No match found
    },
    /** Get short name for region */
    getShortByRegion(region) {
      const regionShortMap = {
        "Banff_Canmore": "Banff",
        "Barrie": "SON",
        "Barrie_Proper": "SON",
        "Calgary": "CAL",
        "Calgary_Outskirts": "CAL",
        "Edmonton": "EDM",
        "Edmonton_Outskirts": "EDM",
        "Gatineau": "OTT",
        "Halifax": "HFX",
        "Hamilton": "HAM",
        "Hamilton_Outskirts": "HAM",
        "Kelowna": "KEL",
        "Kelowna_Surrounding": "KEL",
        "Kingston": "Kingston",
        "Kitchener_Waterloo": "SON",
        "Langley": "VAN",
        "Lethbridge": "LETH",
        "London": "SON",
        "Maritimes": "MAR",
        "Maritimes_NB": "MAR",
        "Maritimes_NS": "MAR",
        "Maritimes_PEI": "MAR",
        "Montreal": "MTL",
        "Northern_AB": "N.AB",
        "Okanagan": "OKN",
        "Ottawa": "OTT",
        "Ottawa_Restricted": "OTT",
        "Ottawa_Surrounding": "OTT",
        "Quebec_City": "QC",
        "Really_Rural_MB": "MB",
        "Regina": "REG",
        "Rural_MB": "MB",
        "Saskatoon": "SASK",
        "Southern_AB": "S.AB",
        "Southern_Ontario": "SON",
        "St_Catharine's_Area": "SON",
        "Surrounding_VAC": "VIC",
        "Toronto": "TOR",
        "Toronto_Outskirts": "TOR",
        "Toronto_Restricted": "TOR",
        "Vancouver": "VAN",
        "Vancouver_Outskirts": "VAN",
        "Victoria": "VIC",
        "Winnipeg": "WPG",
        "Winnipeg_Outskirts": "WPG",
        "Winnipeg_Surrounding": "WPG"
      };

      return regionShortMap[region] || region;
    }
  }
};
